import API from "@utils/plugins/API";

const GearClassService = {
  all: (params) => {
    return API.get("gear-classes", { params: params });
  },
  create: (name, name_eng, description) => {
    return API.post("gear-classes", {
      name,
      name_eng,
      description,
    });
  },
  update: (id, name, name_eng, description) => {
    return API.put(`gear-classes/${id}`, {
      name,
      name_eng,
      description,
    });
  },
  find: (id) => {
    return API.get(`gear-classes/${id}`);
  },
  destroy: (id) => {
    return API.delete(`gear-classes/${id}`);
  },
};

export default GearClassService;
